import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "../../../../globals/backend/authClient";
import axios from "axios";
import Selecter from "./selecter";
import HandleFile from "./handlefile";
import { getStorage, ref, listAll, getDownloadURL, deleteObject, uploadBytes } from "../../../../globals/backend/storageClient";
import InfoViewer from "./info_viewer";
import InserisciOffertaOrdine from "./offertaordine";
import TicketChatBox from "./ticket_chatbox";
import { deleteTicket, updateTicket } from "../../../../globals/backend/ticketsApi";

function TicketViewer({ navOpened, data, handleChiudi, onTicketDelete, onTicketConcludi }) {

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const parsed = new Date(dateString);
        if (Number.isNaN(parsed.getTime())) return dateString;
        return parsed.toLocaleString("it-IT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const Titolo = data.Titolo;
    const decodedMessaggio = decodeURIComponent(data.Messaggio);
    const ID = data.ID;
    const Email = data.Email;
    const Data = formatDate(data.Data);
    const Nome = data.Nome;
    const [Risposta, setRisposta] = useState("");

    const [isAdmin, setIsAdmin] = useState(false);
    const auth = getAuth();
    const [alreadyFiles, setAlreadyFiles] = useState([]);

    const [priorita, setPriorita] = useState(data.Priorita);
    const [tipoSWHW, setTipoSWHW] = useState(data.Tipo);

    const [editableTitolo, setEditableTitolo] = useState(Titolo);
    const [editableMessaggio, setEditableMessaggio] = useState(decodedMessaggio);
    const [lastMessaggio, setLastMessaggio] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [isAnswering, setIsAnswering] = useState(false);
    const [seeInfo, setSeeInfo] = useState(false);

    const [showSuccessPrendiMessage, setShowSuccessPrendiMessage] = useState(false);
    const [showErrorPrendiMessage, setShowErrorPrendiMessage] = useState(false);

    const [showOfferta, setShowOfferta] = useState(false);


    const handleSuccessPrendiMessage = () => {
        setShowSuccessPrendiMessage(true);
        setTimeout(() => setShowSuccessPrendiMessage(false), 2000); // Nasconde il messaggio di successo dopo 2 secondi
    };

    const handleErrorPrendiMessage = () => {
        setShowErrorPrendiMessage(true);
        setTimeout(() => setShowErrorPrendiMessage(false), 2000); // Nasconde il messaggio di errore dopo 2 secondi
    };

    useEffect(() => {
        setRisposta(data.Risposta ? decodeURIComponent(data.Risposta) : null);
    }, [data]);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAdmin(!!user && user.email.includes('admin@auth.com'));
        });
        return () => unsubscribe();
    }, [auth]);

    const handleDelete = async () => {

        const userConfirmed = window.confirm("Sei sicuro di voler eliminare questo ticket e tutti i file associati?");

        if (!userConfirmed) {
            return;
        }

        try {
            await deleteTicket(ID);
            onTicketDelete(ID);
            handleSuccessPrendiMessage();

            const storage = getStorage();
            const folderRef = ref(storage, `ticket/${ID}/`);

            try {
                const fileList = await listAll(folderRef);
                const deletePromises = fileList.items.map((fileRef) => deleteObject(fileRef));
                await Promise.all(deletePromises);
            } catch (storageError) {
                console.error(`Errore nell'eliminazione dei file associati al ticket ${ID}:`, storageError);
                handleErrorPrendiMessage();
            }
        } catch (error) {
            console.error("Errore nell'eliminazione del ticket:", error);
            handleErrorPrendiMessage();
        }
    };

    const handleConcludi = async () => {


        const userConfirmed = window.confirm("Sei sicuro di voler concludere questo ticket?");

        if (!userConfirmed) {
            return;
        }

        try {
            await updateTicket(ID, { Stato: 2 });
            onTicketConcludi(ID);
            handleSuccessPrendiMessage();
        } catch (error) {
            console.error("Errore nel cambiamento di stato del ticket:", error);
            handleErrorPrendiMessage();
        }
        try {
            const custom = "Sc38ahD38sW31Hshue";

            const emailData2 = {
                to: Email, // Assuming Autore is the email address of the ticket author
                subject: "TICKET CONCLUSO",
                text: `Il tuo ticket aperto in data ${Data} di ${Nome}:\n \n ${decodedMessaggio}\n \n e' stato concluso da Scanteq srl, siamo lieti di aiutarvi!`,
            };

            /*const response = await axios.post(
                "https://scanteq.com/php/send-email.php",
                emailData2,
                {
                    headers: {
                        "Custom-Header": custom,
                    },
                }
            );*/
            handleSuccessPrendiMessage();
        } catch (error) {
            console.error("Errore nell'invio dell'e-mail:", error);
            handleErrorPrendiMessage();
        }
    };

    const handlePrendiInCarico = async () => {

        const userConfirmed = window.confirm("Sei sicuro di voler prendere in carico questo ticket?");

        if (!userConfirmed) {
            return;
        }

        try {
            await updateTicket(ID, { Stato: 1 });
            onTicketConcludi(ID);
            handleSuccessPrendiMessage();
        } catch (error) {
            console.error("Errore nel cambiamento di stato del ticket:", error);
            handleErrorPrendiMessage();
            return;
        }


        try {
            const emailData = {
                to: Email, // Assuming Autore is the email address of the ticket author
                subject: "TICKET PRESO IN CARICO",
                text: `Il tuo ticket aperto in data ${Data} di ${Nome}:\n \n ${decodedMessaggio}\n \n e' stato preso in carico da Scanteq srl`,
            };

            const custom = "Sc38ahD38sW31Hshue";

            /*const response = await axios.post(
                "https://scanteq.com/php/send-email.php",
                emailData,
                {
                    headers: {
                        "Custom-Header": custom,
                    },
                }
            );
            onTicketConcludi();*/
            handleSuccessPrendiMessage();
        } catch (error) {
            handleErrorPrendiMessage();
            console.error("Errore nell'invio dell'e-mail:", error);
            // Puoi aggiungere il codice per gestire l'errore qui
        }
    };

    const handleIndietro = () => {
        setIsEditing(false);
    }

    const handleSave = async () => {

        const userConfirmed = window.confirm("Sei sicuro di voler modificare questo ticket?");

        if (!userConfirmed) {
            return;
        }

        try {
            await updateTicket(ID, {
                Titolo: editableTitolo,
                Messaggio: encodeURIComponent(editableMessaggio),
                Tipo: tipoSWHW,
                Priorita: priorita === "Normale" ? 0 : priorita === "Importante" ? 1 : priorita === "Urgente" ? 2 : 0,
            });
            handleSuccessPrendiMessage();
            setIsEditing(false);
            onTicketConcludi();
        } catch (error) {
            console.error("Errore nel salvataggio del ticket:", error);
            handleErrorPrendiMessage();
        }
    };

    const Choices1 = [
        {
            icon: '❗️',
            description: 'Urgente'
        },
        {
            icon: '⚠️',
            description: 'Importante'
        },
        {
            icon: '✅',
            description: 'Normale'
        }
    ];

    const Choices2 = [
        {
            icon: '💻',
            description: 'Software'
        },
        {
            icon: '🔧',
            description: 'Hardware'
        }
    ];


    const getFilesFromFirebase = async (ticketId) => {
        const storage = getStorage();
        const storageRef = ref(storage, `ticket/${ticketId}/`);

        try {
            const fileList = await listAll(storageRef);

            const filesData = await Promise.all(
                fileList.items.map(async (fileRef) => {
                    const url = await getDownloadURL(fileRef);
                    return { name: fileRef.name, url: url }; // Oggetto con nome e URL del file
                })
            );

            setAlreadyFiles(filesData); // Aggiorna lo stato con gli URL dei file
        } catch (error) {
            console.error(`Errore nel recupero dei file per il ticket ${ticketId}:`, error);
        }
    };

    useEffect(() => {
        getFilesFromFirebase(ID);
    }, [ID]);


    const handleCaricaFilesReturn = (files) => {
        setAlreadyFiles(files);
    };

    const handleRispondi = async () => {

        const userConfirmed = window.confirm("Sei sicuro di voler rispondere a questo ticket?");

        if (!userConfirmed) {
            return;
        }

        const ID = data.ID;
        const messaggio = editableMessaggio;

        if (!ID || !messaggio) {
            console.error("ID o messaggio mancante.");
            return;
        }

        try {
            await updateTicket(ID, { Risposta: messaggio });
            uploadFilesToFirebase(alreadyFiles, ID);
            handleSuccessPrendiMessage();
            onTicketConcludi();
            setRisposta(messaggio);
            setIsAnswering(false);
        } catch (error) {
            console.error('Errore nella richiesta di risposta:', error);
            handleErrorPrendiMessage();
        }
    };

    const uploadFilesToFirebase = async (files, ticketId) => {
        const storage = getStorage();

        for (let file of files) {
            const storageRef = ref(storage, `ticket/${ticketId}/${file.name}`);

            try {
                // Prova a ottenere l'URL del file per verificare se esiste
                await getDownloadURL(storageRef);
            } catch (error) {
                // Se il file non esiste (errore 404), procedi al caricamento
                if (error.code === 'storage/object-not-found') {
                    try {
                        await uploadBytes(storageRef, file);
                    } catch (uploadError) {
                        console.error(`Errore nel caricamento del file ${file.name}:`, uploadError);
                    }
                } else {
                    console.error(`Errore nel controllo dell'esistenza del file ${file.name}:`, error);
                }
            }
        }
    };


    const handleApriRispondi = () => {
        setIsAnswering(true);
        setLastMessaggio(editableMessaggio);
        setEditableMessaggio(Risposta);
    }

    const handleIndietroRisposta = () => {
        setIsAnswering(false);
        setEditableMessaggio(lastMessaggio);
    }

    const handleAggiungiOffertaOrdine = () => {
        setShowOfferta(true);
    }

    const handleSuccessOfferta = () => {
        setShowOfferta(false);
        handleSuccessPrendiMessage();
        onTicketConcludi();
    }

    const handleErrorOfferta = () => {
        setShowOfferta(false);
        handleErrorPrendiMessage();
        onTicketConcludi();
    }

    return (
        <>
            <div className={`divApertoTicketMessaggio ${navOpened ? "padding-leftTickets" : ""}`}>
                <div className={`div-ticket-opened ${isEditing ? "modifying" : ""}`}>
                    <span onClick={handleChiudi} className="chiudiDivxTicket">
                        &times;
                    </span>

                    {/* Se è in modalità di modifica, mostra l'input, altrimenti mostra il titolo */}
                    {isEditing ? (
                        <input
                            className="div-ticket-opened-title width100"
                            type="text"
                            value={editableTitolo}
                            onChange={(e) => setEditableTitolo(e.target.value)}
                        />
                    ) : (
                        <div className="div-ticket-opened-title">{editableTitolo}</div>
                    )}

                    <div className="div-ticket-toolbar">
                        {isEditing ? (
                            <>
                                <Selecter Status="Priorità" Choices={Choices1} setSelection={setPriorita} AlreadySetted={priorita}></Selecter>
                                <Selecter Status="Tipo" Choices={Choices2} setSelection={setTipoSWHW} AlreadySetted={tipoSWHW}></Selecter>
                                <button className="div-ticket-toolbar-btnmodify" onClick={handleIndietro}>Indietro</button>
                                <button className="div-ticket-toolbar-btnmodify" onClick={handleSave}>Salva</button>

                            </>
                        ) : (
                            <>
                                {!isAnswering &&
                                    <>
                                        <button className="div-ticket-toolbar-btnmodify" onClick={() => setIsEditing(true)}>Modifica</button>
                                        <button className="div-ticket-toolbar-btnmodify" onClick={() => setSeeInfo(true)}>Vedi info</button>
                                        <HandleFile isAdmin={isAdmin} handleCaricaFilesReturn2={handleCaricaFilesReturn} ticketID={ID} title="Vedi allegati" VediAllegati={true} AlreadyFiles={alreadyFiles} />
                                    </>
                                }
                                {
                                    isAnswering &&
                                    <>
                                        <button className="div-ticket-toolbar-btnmodify" onClick={handleRispondi}>Salva</button>
                                        <button className="div-ticket-toolbar-btnmodify" onClick={handleIndietroRisposta}>Indietro</button>
                                        <HandleFile isAdmin={isAdmin} handleCaricaFilesReturn2={handleCaricaFilesReturn} ticketID={ID} title="Aggiungi allegati" AlreadyFiles={alreadyFiles} />                                    </>
                                }
                            </>
                        )}

                        {isAdmin && !isEditing && !isAnswering && (
                            <>
                                <button
                                    className="div-ticket-toolbar-btnmodify"
                                    onClick={handleDelete}
                                >
                                    Elimina
                                </button>
                                <button
                                    className="div-ticket-toolbar-btnmodify"
                                    onClick={handleConcludi}
                                >
                                    Concludi
                                </button>
                                <button
                                    className="div-ticket-toolbar-btnmodify"
                                    onClick={handlePrendiInCarico}
                                >
                                    Prendi in carico
                                </button>
                                {/*<button
                                    className="div-ticket-toolbar-btnmodify"
                                    onClick={handleApriRispondi}
                                >
                                    Rispondi
                        </button>*/}
                                <button
                                    className="div-ticket-toolbar-btnmodify"
                                    onClick={handleAggiungiOffertaOrdine}
                                >
                                    Aggiungi Offerta/Ordine
                                </button>
                            </>
                        )}
                    </div>

                    {seeInfo &&
                        <>
                            <InfoViewer handleClose={() => setSeeInfo(false)} data={data}></InfoViewer>
                        </>
                    }

                    {/* Se è in modalità di modifica, mostra una textarea, altrimenti mostra il messaggio */}
                    {/*{isEditing || isAnswering ? (
                        <textarea
                            className={`div-ticket-opened-message${Risposta != null ? "-admin" : ""}`}
                            value={editableMessaggio}
                            onChange={(e) => setEditableMessaggio(e.target.value)}
                        />
                    ) : (
                        <div className={`div-ticket-opened-message${Risposta != null ? "-admin" : ""}`}>
                            {editableMessaggio}
                        </div>
                    )}

                    {Risposta != null && !isAnswering &&
                        <>
                            <div className="div-ticket-response-title">Risposta:</div>
                            <div className={`div-ticket-opened-message-admin`}>
                                {Risposta}
                            </div>
                        </>
                    }*/}
                    <TicketChatBox IDTicket={ID}/>
                </div>

                {showSuccessPrendiMessage && (
                    <div className={`success-message show`}>Successo!</div>
                )}
                {showErrorPrendiMessage && (
                    <div className={`error-message show`}>Errore!</div>
                )}
                {showOfferta && <InserisciOffertaOrdine handleClose={() => setShowOfferta(!showOfferta)} data={data} handleSuccess={handleSuccessOfferta} handleError={handleErrorOfferta} />}
            </div>
        </>
    );

};

export default TicketViewer;
